// Sport Energy Toolbar — værktøjslinje + profil-panel (Fase 6.6.0 — en side kan fravælge selve linjen med data-no-toolbar på .seg-root; pillerne (initSegPills) kører stadig, så natrium- og vejr-kapslerne virker uden navigationen. Svedtesten bruger det for ro. Tidligere: 6.5.0 — 'Min profil' hedder 'Mine tal', og tom-tilstanden forklarer hvad tallene bruges til. Tidligere: 6.4.0 — sider kan udpege placeringen med et #seg-tb-slot-element; guiden bruger det til at lægge linjen i bunden, hvor den ikke konkurrerer med sidens eget hierarki. Uden slot: efter .hero som hidtil. Tidligere: 6.3.0 — render venter på DOM når scriptet loades før .seg-root-markupen; guiden loadede toolbaren i head-rækkefølge og fik aldrig en linje. Tidligere: 6.2.0 — se-seg glidende pille på alle 3-vejs kapsler. Tidligere: 6.0.0 — Træning-pillen tilføjet)
//
// Første sten i R5: én linje på tværs af guiden, svedtesten og
// race-kit byggeren, så atleten kan skifte værktøj med ét tryk og
// se sin profil (målt svedtab, natrium-profil) samlet ét sted.
// Indsættes automatisk efter .hero i .seg-root — ingen markup-krav.
// Sletning er to-trins (tryk igen for at bekræfte) og rydder hele
// profilen via sport-energy-profile.js.

(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var TOOLS = [
    { href: '/pages/find-dine-produkter', label: 'Guiden' },
    { href: '/pages/svedtest', label: 'Svedtest' },
    { href: '/pages/race-kit', label: 'Race-kit' },
    { href: '/pages/traening', label: 'Træning' }
  ];

  function fmtDate(ts) {
    try { return new Date(ts).toLocaleDateString('da-DK'); } catch (e) { return ''; }
  }

  function profileRows() {
    var P = window.SportEnergyProfile;
    var pr = P && P.get ? P.get() : null;
    if (!pr || (!pr.sweatRateMl && !pr.sodium)) {
      return '<p class="seg-tb-empty">Vi har ingen tal på dig endnu. Tag <a href="/pages/svedtest">svedtesten</a> — én vejning før og efter — så regner guiden, race-kittet og træningsberegneren med dit målte svedtab i stedet for et gennemsnit.</p>';
    }
    var h = '';
    if (pr.sweatRateMl) {
      h += '<div class="seg-tb-row"><span>Svedtab</span><strong>' + pr.sweatRateMl + ' ml/t</strong>'
        + '<em>' + (pr.sweatSource === 'test' ? 'målt' : 'manuelt sat')
        + (pr.sweatMeasuredAt ? ' · ' + fmtDate(pr.sweatMeasuredAt) : '') + '</em></div>';
    }
    if (pr.sodium) {
      h += '<div class="seg-tb-row"><span>Natrium</span><strong>'
        + (pr.sodium === 'salt' ? 'Salty sweater (≈1000 mg/L)' : 'Normal (≈650 mg/L)')
        + '</strong><em>fra screening</em></div>';
    }
    h += '<div class="seg-tb-actions"><a href="/pages/svedtest">Opdatér målinger</a>'
      + '<button type="button" id="seg-tb-del" onclick="SEGTB.del()">Slet min profil</button></div>';
    return h;
  }

  function render() {
    var root = document.querySelector('.seg-root');
    if (!root || document.getElementById('seg-toolbar')) return;
    // FASE 6.6.0: en side kan bede sig fri for linjen (men beholde
    // pillerne) med data-no-toolbar. Bruges på svedtesten for ro.
    if (root.hasAttribute('data-no-toolbar')) return;
    var path = window.location.pathname.replace(/\/$/, '');
    var bar = document.createElement('div');
    bar.id = 'seg-toolbar';
    var nav = '<nav class="seg-tb-nav" aria-label="Sport Energy værktøjer">';
    for (var i = 0; i < TOOLS.length; i++) {
      var on = path === TOOLS[i].href;
      nav += on
        ? '<span class="seg-tb-pill seg-tb-on" aria-current="page">' + TOOLS[i].label + '</span>'
        : '<a class="seg-tb-pill" href="' + TOOLS[i].href + '">' + TOOLS[i].label + '</a>';
    }
    nav += '<button type="button" class="seg-tb-pill seg-tb-profile" id="seg-tb-toggle" aria-expanded="false" aria-controls="seg-tb-panel" onclick="SEGTB.toggle()">Mine tal</button></nav>'
      + '<div class="seg-tb-panel" id="seg-tb-panel" hidden></div>';
    bar.innerHTML = nav;
    // FASE 6.4.0: Siden bestemmer placeringen. Findes et slot,
    // lander linjen dér — guiden lægger den i bunden.
    var slot = root.querySelector('#seg-tb-slot');
    if (slot) {
      slot.appendChild(bar);
      return;
    }
    var hero = root.querySelector('.hero');
    if (hero && hero.parentNode === root) {
      root.insertBefore(bar, hero.nextSibling);
    } else {
      root.insertBefore(bar, root.firstChild);
    }
  }

  function toggle() {
    var panel = document.getElementById('seg-tb-panel');
    var btn = document.getElementById('seg-tb-toggle');
    if (!panel || !btn) return;
    var open = panel.hidden;
    if (open) panel.innerHTML = profileRows();
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  var armed = false;
  function del() {
    var btn = document.getElementById('seg-tb-del');
    if (!btn) return;
    if (!armed) {
      armed = true;
      btn.textContent = 'Sikker? Tryk igen for at slette';
      return;
    }
    if (window.SportEnergyProfile) window.SportEnergyProfile.clear();
    armed = false;
    var panel = document.getElementById('seg-tb-panel');
    if (panel) panel.innerHTML = profileRows();
  }

  // ── FASE 4.26.0: glidende se-buy-pille paa 3-vejs kapsler ──
  // Enhver .rk-radio-row med radio-knapper bliver en segmentet kontrol
  // med en hvid pille der glider til det valgte felt. Ren visning —
  // rorer ikke radioernes vaerdier, kun --seg-i/--seg-n + en klasse.
  function initSegPills() {
    var rows = document.querySelectorAll('.rk-radio-row');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var opts = row.querySelectorAll('.seg-opt');
      if (opts.length < 2) continue;
      // Kun rene radio-raekker (ikke chips med blandet indhold).
      var radios = row.querySelectorAll('input[type="radio"]');
      if (radios.length !== opts.length) continue;
      row.classList.add('se-seg');
      row.style.setProperty('--seg-n', opts.length);
      row.style.gridTemplateColumns = 'repeat(' + opts.length + ', 1fr)';
      (function (row, opts) {
        function move() {
          for (var i = 0; i < opts.length; i++) {
            var input = opts[i].querySelector('input[type="radio"]');
            if (input && input.checked) {
              row.style.setProperty('--seg-i', i);
              return;
            }
          }
          row.style.setProperty('--seg-i', 0); // intet valgt endnu
        }
        for (var i = 0; i < opts.length; i++) {
          var input = opts[i].querySelector('input[type="radio"]');
          if (input) input.addEventListener('change', move);
        }
        move();
      })(row, opts);
    }
  }
  // Kapsler kan renderes async (race-kit/traening bygger felter i JS),
  // saa vi koerer ved load OG observerer DOM kort efter.
  function armSegPills() {
    initSegPills();
    var mo = new MutationObserver(function () { initSegPills(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 4000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armSegPills);
  } else {
    armSegPills();
  }

  window.SEGTB = { toggle: toggle, del: del, initSegPills: initSegPills };
  // FASE 6.3.0: Guiden loader toolbaren FØR .seg-root-markupen findes
  // i DOM'en — render() fandt ingen rod og opgav stille. Findes roden
  // ikke endnu, og dokumentet stadig parser, venter vi på DOM'en.
  if (!document.querySelector('.seg-root') && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();